const gradients = {
  pending:     { bg: 'linear-gradient(135deg,#f59e0b,#fbbf24)', color: '#fff' },
  needs_info:  { bg: 'linear-gradient(135deg,#0891b2,#06b6d4)', color: '#fff' },
  approved:    { bg: 'linear-gradient(135deg,#0d1a6e,#4f6ef7)', color: '#fff' },
  rejected:    { bg: 'linear-gradient(135deg,#dc2626,#ef4444)', color: '#fff' },
  in_progress: { bg: 'linear-gradient(135deg,#ea580c,#f97316)', color: '#fff' },
  completed:   { bg: 'linear-gradient(135deg,#7c3aed,#a78bfa)', color: '#fff' },
  user:        { bg: 'linear-gradient(135deg,#0d1a6e,#4f6ef7)', color: '#fff' },
  approver:    { bg: 'linear-gradient(135deg,#ea580c,#f97316)', color: '#fff' },
  it_support:  { bg: 'linear-gradient(135deg,#7c3aed,#a78bfa)', color: '#fff' },
  admin:       { bg: 'linear-gradient(135deg,#060d3a,#0d1a6e)', color: '#F7D506' },
};

const StatusBadge = ({ status }) => {
  const c = gradients[status] || { bg: 'linear-gradient(135deg,#64748b,#94a3b8)', color: '#fff' };
  return (
    <span style={{
      background: c.bg, color: c.color,
      padding: '4px 11px', borderRadius: 12, fontSize: 11.5, fontWeight: 700,
      letterSpacing: 0.4, display: 'inline-block',
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    }}>
      {status?.replace('_', ' ').toUpperCase()}
    </span>
  );
};

export default StatusBadge;
